import tinymce from 'tinymce';

tinymce.IconManager.add('Aula', {
  icons: {
    letters: '<span class="aula-icon icon-texteditor_letters"></span>',
    youtube: '<span class="aula-icon youtube icon-youtube"></span>',
  },
});
